// extracted by css-extract-rspack-plugin
export default {"ClustersDisablerBox":"ClustersDisabler-module__ClustersDisablerBox__sDQSi","ClustersDisablerText":"ClustersDisabler-module__ClustersDisablerText__kHRRv"};